import { createModel } from "@rematch/core";
import {  } from "../shared/api/dtos/IActorDto";
import * as ActorRegistrationApi from "../shared/api/ActorRegistration.api";
import { AxiosError } from "axios";

const invitationModel = createModel({
  state: {
    agentData: {},
  },
  reducers: {
    setAgentData(state, agentData) {
      return {
        ...state,
        agentData,
      };
    },
  },
  effects: (dispatch: any) => ({
    async verifyInvitation(path) {
      try {
        const response = await ActorRegistrationApi.checkInvitationValidity(path);
        const agentData = response.data;

        dispatch.invitationModel.setAgentData(agentData);

        return response;
      } catch(e) {
        return e;
      }
    },
  }),
});

export default invitationModel;
